(function ($) {
  multiVideoV1 = {
    formatter: $('.multi-video-formatter-v1')
  };

  Drupal.behaviors.multiVideoV1 = {
    get: function (key) {
      return multiVideoV1[key];
    },

    set: function (key, val) {
      multiVideoV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var link = thisFormatter.find('.button').attr('href');

        if (typeof link !== 'undefined') {
          thisFormatter.wrapInner('<a href="' + link + '"></a>');
        }

        var videos = thisFormatter.find('.js-single-video');
        var videosContainer = thisFormatter.find('.videos-container');
        var slidesContainer = videosContainer.find('.slides');

        videos.each(function () {
          var li = $('<li></li>').append($(this));

          li.appendTo(slidesContainer);
        });

        videosContainer.flexslider({
          slideshow: false,
          startAt: 0
        });

        /* Done in CSS
      var sliderArrows = videosContainer.find(".flex-direction-nav");
      var arrowTop = (videosContainer.height() / 2) + sliderArrows.find("a").height();
      sliderArrows.css("top", arrowTop);
      */

        var thumbnails = thisFormatter.find('.thumbnail');
        var thumbnailsContainer = thisFormatter.find('.thumbnails-container');

        thumbnails.appendTo(thumbnailsContainer);

        var slider = videosContainer.data('flexslider');

        thisFormatter.find('.flex-next, .flex-prev').on('click', function() {
          pauseAllVideos();
        });

        thumbnails.on('click', function() {
          var index = $(this).index();

          slider.flexAnimate(index);
          pauseAllVideos();
        });

        function pauseAllVideos() {
          thisFormatter.find('.video-wrapper').find('video').each(function () {
            $(this)[0].pause();
          });
        }

        var imagePlaceholders = thisFormatter.find('.image-placeholder.has-video');

        // Remove the click handlers from single-video-v1
        imagePlaceholders.off('click');
        imagePlaceholders.on('click', function() {
        // swap
          var placeholderHeight = $(this).find('img').height();
          var videoContainer = thisFormatter.find('.flex-active-slide').find('.video-wrapper');

          videoContainer.fadeIn(1000);

          // autoplay
          var iframeTag = videoContainer.find('iframe');
          var videoTag = videoContainer.find('video');

          if (iframeTag.length > 0) {
          // autoplay
            iframeTag.css('height', placeholderHeight);
            var iframeSrc = iframe.attr('src');
            var autoplaySrc = iframeSrc + '&autoplay=1';

            iframe.attr('src', autoplaySrc);
          }

          if (videoTag.length > 0) {
          // set player height
            videoTag.css('height', placeholderHeight);

            // autoplay
            videoTag.trigger('click');

            // swap back when video ends
            videoTag.on('ended', function () {
              videoContainer.fadeOut(1000);
            });
          }
        });
      });
    }
  };
})(jQuery);
